import React, { useState } from 'react';
import * as authApi from '../../api/auth';
import { useAuth } from '../../contexts/AuthContext';
import PageHeader from '../../components/common/PageHeader';
import StatusBadge from '../../components/common/StatusBadge';
import { getErrorMessage } from '../../utils/apiError';

export default function MeuPerfil() {
  const { user, setUser } = useAuth();
  const [nome, setNome] = useState(user?.nome || '');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    if (senha && senha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      return;
    }
    setSalvando(true);
    try {
      const payload = { nome };
      if (senha) payload.senha = senha;
      const { data } = await authApi.updateMe(payload);
      setUser(data);
      setSenha('');
      setConfirmarSenha('');
      setSucesso('Perfil atualizado com sucesso.');
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao atualizar perfil.'));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <PageHeader titulo="Editar perfil" />
      <form onSubmit={handleSubmit} className="sf-card p-4" style={{ maxWidth: 520 }}>
        <div className="d-flex align-items-center gap-2 mb-4">
          <span className="sf-cell-sub">E-mail:</span>
          <span className="sf-cell-title" style={{ fontSize: 13.5 }}>{user?.email}</span>
          <StatusBadge status={user?.perfil} />
        </div>

        {erro && (
          <div className="sf-login-alert mb-3">
            <i className="bi bi-exclamation-circle" />
            {erro}
          </div>
        )}
        {sucesso && (
          <div className="sf-login-alert mb-3" style={{ background: 'var(--sf-primary-light)', borderColor: '#cfe0d0', color: 'var(--sf-primary-dark)' }}>
            <i className="bi bi-check-circle" />
            {sucesso}
          </div>
        )}

        <label className="sf-field-label mb-3">
          <span>Nome</span>
          <span className="sf-field">
            <i className="bi bi-person" />
            <input required value={nome} onChange={(e) => setNome(e.target.value)} />
          </span>
        </label>

        <div className="sf-nav-section-title"><span>Senha</span></div>
        <p className="sf-cell-sub mb-3">Deixe em branco para manter a senha atual.</p>

        <label className="sf-field-label mb-3">
          <span>Nova senha (mínimo 8 caracteres)</span>
          <span className="sf-field">
            <i className="bi bi-lock" />
            <input type="password" minLength={8} value={senha} onChange={(e) => setSenha(e.target.value)} />
          </span>
        </label>
        <label className="sf-field-label mb-3">
          <span>Confirmar nova senha</span>
          <span className="sf-field">
            <i className="bi bi-lock" />
            <input type="password" value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} />
          </span>
        </label>

        <button type="submit" className="sf-btn sf-btn-primary" disabled={salvando}>
          {salvando ? 'Salvando...' : 'Salvar alterações'}
        </button>
      </form>
    </div>
  );
}
